import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

import { checkUserJwt } from "../common/api";
import { useQuery } from "react-query";

import { Container, Nav, Navbar, NavDropdown, Spinner, Button } from "react-bootstrap";

import logo from "../assets/img/klett-baza-wiedzy-logo.png";

const NavigationComponent = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [isLogged, setIsLogged] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userNameSurname, setUserNameSurname] = useState("");
  const [redirect, setRedirect] = useState("/");

  useEffect(() => {
    const url = new URL(window.location.href);
 
    if(url.pathname !== "/authorization"){
      setRedirect(url.pathname + url.search);
    }
  }, [])

  useEffect(() => {
    const checkUser = async () => {
      if (localStorage.getItem("jwt") !== null && localStorage.getItem("profile") !== null && isLogged === false) {
        const { firstName, lastName } = JSON.parse(
          localStorage.getItem("profile")
        );
  
        setIsLogged(true);
        setUserNameSurname(firstName + " " + lastName);
      }
    }
  
    checkUser();
    
  }, [setIsLogged]);

  const logout = () => {
    localStorage.clear();
    localStorage.removeItem("jwt");
    localStorage.removeItem("profile");
    localStorage.removeItem("uid");
    localStorage.removeItem("permissions");
    localStorage.removeItem("expires");
    setIsLogged(false);
    window.location.href = "/authorization";
  };

  const loginLink = <Link className="nav-link btn btn-primary text-white" to={"/authorization?redirect=" + redirect}><strong>Zaloguj się</strong></Link>;
  const dropdownMenu = (
    <NavDropdown title={userNameSurname} id="basic-nav-dropdown">
      <NavDropdown.Item onClick={logout}>Wyloguj</NavDropdown.Item>
    </NavDropdown>
  );

  useEffect(() => {
    const checkExpires = () => {
      const currentData = new Date();
      if(
        localStorage.getItem("jwt") !== null && 
        (localStorage.getItem("expires") === null || localStorage.getItem("expires") === 'undefined' || localStorage.getItem("expires") <= currentData.getTime()) && 
        location.pathname !== "/authorization"){
        logout();
      }
    }
    checkExpires();
    const intervalId = setInterval(checkExpires, 30000); // Wywołaj co 5 minut (300000 milisekund)
  })

  let loadingSpinner = loading ? <Nav.Item><Nav.Link eventKey="link-1"><Spinner animation="border" size="sm" /></Nav.Link></Nav.Item> : null
  return (
    <React.Fragment>
      <Navbar bg="light" expand="lg" fixed="top">
        <Container>
          <Navbar.Brand href="/">
            <img
              src={logo}
              alt="Baza wiedzy | Klett Polska sp. z o.o."
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">

              {loadingSpinner}

              <Link className="nav-link" to="/">
                Strona główna
              </Link>
              

              {!isLogged ? loginLink : dropdownMenu}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </React.Fragment>
  );
};

export default NavigationComponent;
